<template>
  <wo-region>
    <wo-layout>
      <wo-title tag-name="h3" v-t="'admin.title'"></wo-title>
      <wo-grid>
          <wo-column width-lg="6" v-for="group in groups" :key="group.name" >
            <wo-card :title="group.name">
              <wo-properties mod-bordered mod-horizontal>
                <template v-for="(prop, index) in group.properties">
                  <wo-properties-label :key="prop.name"><wo-label>{{ prop.name }}</wo-label></wo-properties-label>
                  <wo-properties-value :key="index">{{ prop.value }}</wo-properties-value>
                </template>
              </wo-properties>
            </wo-card>
            <wo-spacer />
          </wo-column>
      </wo-grid>
    </wo-layout>
  </wo-region>
</template>

<script>

import _ from 'lodash'
import { mapState } from 'vuex'

import { infoRepository } from '@/repository/general'

export default {
  computed: mapState({
    currentUser: state => state.identity.currentUser,
    info: state => state.general.info,
    groups () {
      return this.info && _.map(this.info, this.createGroup)
    }
  }),
  created () {
    this.$store.dispatch(infoRepository.find)
  },
  methods: {
    createGroup (value, groupName) {
      return {
        name: groupName,
        properties: _.map(value, (value, key) => {
          return {
            name: key,
            value: value
          }
        })
      }
    }
  }
}
</script>
